import type { IconSvgObject } from './types';

const Comet01Icon: IconSvgObject = [
  ["path", { d: "M4.05025 10.0506C1.31658 12.7843 1.31658 17.2165 4.05025 19.9501C6.78392 22.6838 11.2161 22.6838 13.9497 19.9501L17.899 16.0008M12 2L6.5 7.5M22 12L20 14", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.1213 12.8795C12.2929 14.0511 12.2929 15.9506 11.1213 17.1221C9.94975 18.2937 8.05025 18.2937 6.87868 17.1221C5.70711 15.9506 5.70711 14.0511 6.87868 12.8795C8.05025 11.7079 9.94975 11.7079 11.1213 12.8795Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 2L16 4M22 6L15 13M14 6L7 12.7588", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default Comet01Icon;
